import { CircularProgress } from "@mui/joy";
import { useGetTasksQuery } from "../../../api/tareas/tareaApi";
import { AddTaskButton } from "./AddTaskButton";
import { Container } from "./Container";
import { TaskItem } from "./TaskItem";
import { ErrorMessage } from "../../UtilitiesComponents/ErrorMessage";
import { TaskDetail } from "../TaskDetail";
import { useTaskManager } from "../../../hooks/userTaskManager";
import { OptionMenu } from "./OptionMenu";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export function TaskManager() {
    const { openDetails, currentTaskId, closeTaskDetails, currentEmpresaId } = useTaskManager()

    const {
        data: tasks,
        isFetching,
        isLoading,
        isError,
        isSuccess
    } = useGetTasksQuery({ empresaId: currentEmpresaId, formatoFecha: "Nombre" });

    if(isError)
        return (
        <Container>
            <div className="flex flex-col gap-y-4 h-full overflow-hidden flex-1 p-3">
                <ErrorMessage>
                    Error al cargar la información.
                </ErrorMessage>
            </div>
        </Container>
        );
    
    if(isFetching || isLoading || !isSuccess)
        return (
        <Container>
            <div className="flex flex-col gap-y-4 h-full overflow-hidden flex-1 p-3">

                <div className="flex-1 overflow-auto flex flex-col justify-center items-center gap-y-3">
                    <CircularProgress />
                </div>
            </div>
        </Container>
        );
    
    return (
        <Container>
            <div className="flex flex-col gap-y-4 h-full overflow-hidden flex-1 p-3">
                <div className="flex justify-between">
                    <p className="text-xl font-bold">Lista de tareas de {tasks?.empresa}</p>
                    <OptionMenu />
                </div>

                <div className="flex-1 flex flex-col gap-y-3 overflow-auto ">
                    {tasks.tareas.length == 0
                    ?
                    <p className="text-center font-semibold text-sm italic text-gray-500">No hay tareas creadas</p>
                    :
                    tasks.tareas.map((task, index) => (
                        <TaskItem
                            key={index}
                            task={task} />
                    ))}
                </div>

                <AddTaskButton />
            </div>

            {openDetails && currentTaskId !== 0 && (
            <div className="flex-none flex flex-col border-l-[1px] border-gray-300 bg-slate-50 w-[480px]">
                <div className="flex justify-end rounded h-[26px] px-4 py-3">
                    <button
                        onClick={() => closeTaskDetails()}>
                        <CloseRoundedIcon sx={{
                            ":hover": {
                                backgroundColor: "#e2e8f0", 
                            },
                            borderRadius: 1,
                        }}/>
                    </button>
                </div>

                <div className="h-full overflow-hidden">
                    <div className="flex flex-col h-full overflow-auto flex-none">
                        <TaskDetail
                            taskId={currentTaskId}/>
                    </div>
                </div>
            </div>
            )}
        </Container>
    )
}
